/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiClassificationItemFromJSON, ApiClassificationItemToJSON, } from './ApiClassificationItem';
import { ApiExternalAdGroupFromJSON, ApiExternalAdGroupToJSON, } from './ApiExternalAdGroup';
import { ApiExternalCampaignFromJSON, ApiExternalCampaignToJSON, } from './ApiExternalCampaign';
import { ApiExternalEntityStatusFromJSON, ApiExternalEntityStatusToJSON, } from './ApiExternalEntityStatus';
import { ApiServiceFromJSON, ApiServiceToJSON, } from './ApiService';
import { ApiUTMEntityStatusFromJSON, ApiUTMEntityStatusToJSON, } from './ApiUTMEntityStatus';
import { ApiUTMEntityTypeFromJSON, ApiUTMEntityTypeToJSON, } from './ApiUTMEntityType';
export function ApiUTMEntityFromJSON(json) {
    return ApiUTMEntityFromJSONTyped(json, false);
}
export function ApiUTMEntityFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adCreativeTitle': !exists(json, 'adCreativeTitle') ? undefined : json['adCreativeTitle'],
        'classificationItems': !exists(json, 'classificationItems') ? undefined : (json['classificationItems'].map(ApiClassificationItemFromJSON)),
        'entityStatus': !exists(json, 'entityStatus') ? undefined : ApiExternalEntityStatusFromJSON(json['entityStatus']),
        'externalAdgroup': !exists(json, 'externalAdgroup') ? undefined : ApiExternalAdGroupFromJSON(json['externalAdgroup']),
        'externalCampaign': !exists(json, 'externalCampaign') ? undefined : ApiExternalCampaignFromJSON(json['externalCampaign']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'imageUrl': !exists(json, 'imageUrl') ? undefined : json['imageUrl'],
        'landingPathId': !exists(json, 'landingPathId') ? undefined : json['landingPathId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'rezonateUrl': !exists(json, 'rezonateUrl') ? undefined : json['rezonateUrl'],
        'service': !exists(json, 'service') ? undefined : ApiServiceFromJSON(json['service']),
        'splitCampaignId': !exists(json, 'splitCampaignId') ? undefined : json['splitCampaignId'],
        'status': !exists(json, 'status') ? undefined : ApiUTMEntityStatusFromJSON(json['status']),
        'type': !exists(json, 'type') ? undefined : ApiUTMEntityTypeFromJSON(json['type']),
    };
}
export function ApiUTMEntityToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'adCreativeTitle': value.adCreativeTitle,
        'classificationItems': value.classificationItems === undefined ? undefined : (value.classificationItems.map(ApiClassificationItemToJSON)),
        'entityStatus': ApiExternalEntityStatusToJSON(value.entityStatus),
        'externalAdgroup': ApiExternalAdGroupToJSON(value.externalAdgroup),
        'externalCampaign': ApiExternalCampaignToJSON(value.externalCampaign),
        'id': value.id,
        'imageUrl': value.imageUrl,
        'landingPathId': value.landingPathId,
        'name': value.name,
        'rezonateUrl': value.rezonateUrl,
        'service': ApiServiceToJSON(value.service),
        'splitCampaignId': value.splitCampaignId,
        'status': ApiUTMEntityStatusToJSON(value.status),
        'type': ApiUTMEntityTypeToJSON(value.type),
    };
}
